import Cookies from "js-cookie";

class FormSalutation {

	constructor( fieldsetEl ) {
		this.fieldsetEl = fieldsetEl;

		fieldsetEl.addEventListener( 'change', ( ev ) => this.onSelect( ev.target ) );

		if ( ! fieldsetEl.querySelector( ':checked' ) ) {
			this.setInitialValue();
		}
	}

	setInitialValue() {
		const preferredSalutation = localStorage.getItem( 'preferredSalutation' ) || Cookies.get( 'salutation' );
		if ( preferredSalutation ) {
			const radioEl = Array.from( this.fieldsetEl.querySelectorAll( 'input[data-salutation]' ) ).find( inputEl => inputEl.dataset.salutation === preferredSalutation );
			if ( radioEl ) {
				radioEl.checked = true;
				localStorage.setItem( 'preferredSalutation', radioEl.dataset.salutation );
			}
		}
	}

	onSelect( radioEl ) {
		if ( ! radioEl.dataset.salutation ) {
			return;
		}

		// Use localStorage instead of cookie, so we don't send useless cookies with each request.
		localStorage.setItem( 'preferredSalutation', radioEl.dataset.salutation );
	}
}

const initFormSalutation = ( scopeEl = document ) => {
	const fieldsetEls = Array.from( scopeEl.getElementsByClassName( 'o-radio o-radio--salutation' ) );
	fieldsetEls.forEach( ( fieldsetEl ) => {
		fieldsetEl.SL_FORM_SALUTATION ??= new FormSalutation( fieldsetEl );
	} );
}

export {
	FormSalutation as default,
	initFormSalutation
}
